import Vue from 'vue'
import VueRouter from 'vue-router'
import '@/assets/css/reset.css'
import '@/assets/css/style.css'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Mainindex',
    component: () => import('../views/index.vue')
  },
  {
    path: '/history',
    name: 'History',
    component: () => import('../views/history.vue')
  },
  {
    path: '/login',
    name: 'AdminLogin',
    component: () => import('../views/admin/login.vue')
  },
  {
    path: '/admin',
    name: 'AdminDashboard',
    component: () => import('../views/admin/dashboard.vue')
  },
  {
    path: '/admin/apply',
    name: 'AdminApplyList',
    component: () => import('../views/admin/apply_List.vue')
  }
]
const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});


export default router
